import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './mainpage.css';

import logo from '../static/hkfws-logo.png';
import YDCImage from '../static/YDC.png';
import IgniteImage from '../static/Ignite.png';

import {
    mainpageUpdateTrad,
    mainpageUpdateSimp,
    mainpageUpdateEng
} from '../../modules/mainpage';

class MainTopNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLang: 2,
            language: [["en", "EN", "inline"], ["sc", "简", "inline"], ["tc", "繁", "none"]],
        }
    }
    componentDidMount() {
        if (!this.props.language) {
            this.props.mainpageUpdateTrad();
            console.log(this.props.language)
        }
    }

    changeLanguage = (id) => {
        switch (id) {
            case 0: 
                this.props.mainpageUpdateEng();
                break;
            case 1: 
                this.props.mainpageUpdateSimp();
                break;
            case 2: 
                this.props.mainpageUpdateTrad();
                break;
            default: 
                this.props.mainpageUpdateTrad();
                break;
        }

        this.setState(state => {
            const currentLang = id;
            const language = state.language.map((item, j) => {
                if (j === id) {
                    item[2] = "none";
                    return item;
                } else {
                    item[2] = "inline";
                    return item;
                }
            });

            return {
                currentLang, language,
            };
        });
    }

    render() {
        return (
            <div className="header">
                <div className="logo-container">
                  <a onClick={() => this.props.history.push("/")}><img src={logo} className="logo" ></img></a>
                  <img src={YDCImage}/>
                  <img src={IgniteImage}/>
                </div>
                <div className="language">
                    <a onClick={() => this.changeLanguage(0)} style={{ display: this.state.language[0][2] }}>{this.state.language[0][1]}</a>
                    <a onClick={() => this.changeLanguage(1)} style={{ display: this.state.language[1][2] }}>{this.state.language[1][1]}</a>
                    <a onClick={() => this.changeLanguage(2)} style={{ display: this.state.language[2][2] }}>{this.state.language[2][1]}</a>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            mainpageUpdateTrad,
            mainpageUpdateSimp,
            mainpageUpdateEng
        },
        dispatch
    );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainTopNav));